import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
  /** Kompakte Darstellung für Teilbereiche (z. B. PDF-Vorschau). */
  bereich?: string;
}

interface State {
  fehler: Error | null;
}

/** Fängt Render-Fehler ab, damit ein Fehler nicht die ganze App weiß werden lässt. */
export class FehlerGrenze extends Component<Props, State> {
  state: State = { fehler: null };

  static getDerivedStateFromError(fehler: Error): State {
    return { fehler };
  }

  componentDidCatch(fehler: Error, info: ErrorInfo): void {
    console.error("UI-Fehler", this.props.bereich ?? "App", fehler, info.componentStack);
  }

  render(): ReactNode {
    if (!this.state.fehler) return this.props.children;
    if (this.props.bereich) {
      return (
        <div className="rounded-xl border border-ampel-rot/30 bg-ampel-rotHell p-4 text-sm text-ampel-rot">
          <p className="font-semibold">{this.props.bereich} konnte nicht angezeigt werden.</p>
          <button type="button" className="mt-2 underline" onClick={() => this.setState({ fehler: null })}>
            Erneut versuchen
          </button>
        </div>
      );
    }
    return (
      <div className="mx-auto mt-24 max-w-lg rounded-2xl border border-neutral-200 bg-white p-8 text-center shadow-karte">
        <p className="text-4xl" aria-hidden>
          ⚠️
        </p>
        <h1 className="mt-4 text-xl font-semibold">Da ist etwas schiefgelaufen</h1>
        <p className="mt-2 text-sm text-neutral-600">
          Die Ansicht konnte nicht geladen werden. Deine gespeicherten Daten sind nicht betroffen.
        </p>
        <pre className="mt-4 overflow-x-auto rounded bg-neutral-50 p-3 text-left text-xs text-neutral-500">{this.state.fehler.message}</pre>
        <div className="mt-6 flex justify-center gap-3">
          <button type="button" className="rounded-lg border px-4 py-2 text-sm font-semibold" onClick={() => this.setState({ fehler: null })}>
            Erneut versuchen
          </button>
          <button type="button" className="rounded-lg bg-marke px-4 py-2 text-sm font-semibold text-white" onClick={() => window.location.reload()}>
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }
}
